var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13281 14.4277C7.13281 10.4884 10.3263 7.29492 14.2656 7.29492H36.3125V29.3418C36.3125 33.2811 33.119 36.4746 29.1797 36.4746H7.13281V14.4277Z",
    fill: "#85276B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6875 14.4277C46.6875 10.4884 49.881 7.29492 53.8203 7.29492H75.8672V29.3418C75.8672 33.2811 72.6737 36.4746 68.7344 36.4746H46.6875V14.4277Z",
    fill: "#85276B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6875 53.6582C46.6875 49.7189 49.881 46.5254 53.8203 46.5254H75.8672V68.5723C75.8672 72.5116 72.6737 75.7051 68.7344 75.7051H46.6875V53.6582Z",
    fill: "#85276B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13281 53.6582C7.13281 49.7189 10.3263 46.5254 14.2656 46.5254H36.3125V68.5723C36.3125 72.5116 33.119 75.7051 29.1797 75.7051H7.13281V53.6582Z",
    fill: "#85276B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.922eda4ef5caea9559621327ba5adf11.svg";
export { ForwardRef as ReactComponent };